import { useCallback, useEffect, useRef } from "react"

interface UsePollingOptions {
	callback: () => void | Promise<void>
	intervalMs: number
	enabled?: boolean
}

export const usePolling = ({
	callback,
	intervalMs,
	enabled = true,
}: UsePollingOptions) => {
	const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null)
	const callbackRef = useRef(callback)

	useEffect(() => {
		callbackRef.current = callback
	}, [callback])

	const tick = useCallback(() => {
		callbackRef.current()
	}, [])

	useEffect(() => {
		if (!enabled) {
			return
		}

		intervalRef.current = setInterval(tick, intervalMs)

		return () => {
			if (intervalRef.current) {
				clearInterval(intervalRef.current)
				intervalRef.current = null
			}
		}
	}, [enabled, intervalMs, tick])
}
